

import React from 'react';
import ZProps from './zprops';
import ZLog from './zlog';
import ZUtil from "./zutil";
import { APP } from "./App";
import ZNetwork from './znetwork';
import AMCConstants from './AMCConstants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLock, faLockOpen, faCircle, faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { KINDS } from './AMCConstants';
import ZAPI from './zapi';

const AMC = {
	init: function() {
		ZNetwork.get("tracking", (err, trackings) => {
			if (!err) {
				Object.keys(trackings || {}).forEach( t => ZProps.set(t, trackings[t]) );
				ZProps.set(AMCConstants.TRACKINGS_LOADED, true);
			}
			AMC.loadSettings(["wtf", "freakout", "helpmechoose", "rockpile", "themes"], (err) => {});
		});
		ZAPI.startPollingCapacity();
/*
		this.usage_subscription = setInterval( () => {
			ZAPI.getCapacity((err, results) => {
				if (!err) {
					let group = ZProps.get("usergroup");
					group.capacity = results.capacity;
					ZProps.set("usergroup", group);
				}
			}) }, 5*60*1000);
*/
	},
	// createType
	create: function(component, spec, imp, callback) {
		ZNetwork.post("thing", { component: component, imp: imp, spec: spec }, function(err, payload) {
			if (err) {
				return callback(err);
			}
			ZProps.set(payload.component.uri, payload.component);
			ZProps.set(payload.spec.uri, payload.spec);
			ZProps.set(payload.imp.uri, payload.imp);
			callback(err, payload);
		});
	},
	get: function(uri, callback) {
		ZNetwork.get("thing", uri, (err, thing) => {
			if (!err) {
				ZProps.set(uri, thing);
			}
			callback(err, thing);
		});
	},
	updateRaw: function(uri, text, callback) {
		ZNetwork.post("thing", "raw", { uri: uri, raw: text }, (err, payload) => {
			if (!err) {
				ZProps.set(payload.uri, payload.component);
				ZProps.set(payload.uri + ".spec", payload.spec);
				ZProps.set(payload.uri + ".imp", payload.imp);
			}
			callback(err, payload);
		});
	},
	updateURI: function(uri, newuri, callback) {
		ZNetwork.post("thing", "uri", { uri: uri, newuri: newuri }, (err) => {
			callback(err);
		});
	},
	save: function(uri, callback) {
		ZLog.debug("AMC.save " + (typeof uri === "string" ? uri : uri.uri));
		if (typeof uri !== "string" && uri.uri) {
			ZProps.set(uri.uri, uri);
			uri = uri.uri;
		}
		let bundle = this.serialize(ZProps.get(uri));
		ZNetwork.post("thing", uri, null, { data: bundle }, function(err) {
			if (bundle.kind === "service") {
				ZProps.set("service:changed:" + bundle.uri, Date.now());
			}
			ZProps.set("mythings", null);
			if (callback) {
				callback(err);
			}
		});
	},
	fork: function(uri, callback) {
		if (typeof uri !== "string" && uri.uri) {
			ZProps.set(uri.uri, uri);
			uri = uri.uri;
		}
		let data = ZProps.get(uri);
		let bundle = this.serialize(data);
		ZNetwork.post("version", { service_uri: bundle.uri, data: bundle }, function(err, versioned_uri) {
			if (!err) {
				if (bundle.kind === "service") {
					ZProps.set("service:changed:" + bundle.uri, Date.now());
				}
				data.last_version = parseInt(versioned_uri.split(":")[1], 10);
				data.version = data.last_version;
ZLog.log("data forked:", { data: data });
				ZProps.set(data.uri, data);
			}
			if (callback) {
				callback(err, versioned_uri);
			}
		});
	},
	update: function(uri, props, callback) {
		if (typeof uri !== "string" && uri.uri) {
			let data = uri;
			ZProps.set(data.uri, data);
			uri = data.uri;
			callback = props;
			props = data;
		} else {
			// 6-25-2020
			let data = ZProps.get(uri);
			Object.assign(data, props);
			ZProps.set(uri, data);
		}
		ZNetwork.post("update", uri, null, { data: props }, function(err) {
			if (callback) {
				callback(err);
			}
		});
	},
	report: function(uri, context, callback) {
		ZNetwork.post("report", null, null, { uri: uri, context: context }, function(err) {
			if (callback) {
				callback(err);
			}
		});
	},
	mergeSpecs(high, low) {
		let combo = high.slice();
		let common_spec_by_field = {};
		high.forEach( f => common_spec_by_field[f.field] = f );
		low.forEach( f => {
			if (!common_spec_by_field[f.field]) {
				combo.push(f);
			}
		});
		return combo;
	},
	saveUser: function(user, settings, callback) {
		ZNetwork.post("user", null, null, { user: user, settings: settings }, function(err) {
			if (!err) {
				ZProps.set("user", user);
				ZProps.set("usersettings", settings);
			}
			if (callback) {
				callback(err);
			}
		});
	},
	list(uris, callback) {
		ZNetwork.post("things", { uris: uris }, (err, things) => {
			if (err) {
				APP.setError(err);
				things = [];
			}
			things.forEach(t => { if (t) { ZProps.set(t.uri, t) } });
			callback(err, things);
		});
	},
	isEditable: function(app) {
		var user = ZProps.get("user");
		//return app.uri.startsWith(user.uri + "/") || user.uri === app.owner || (app.group === user.group); 
		return user.uri === app.owner || app.group === user.group; 
	},
	isOwner: function(item) {
		var user = ZProps.get("user");
		return item.owner === user.uri || item.group === user.group;
	},
	isCloneable: function(item) {
		return this.isEditable(item) || item.permissions === "public";
	},
	isSourceViewable: function(item) {
		return this.isCloneable(item);
	},
	// NOT UNDOABLE
	clone: function(model_uri, callback) {
		var model = ZProps.get(model_uri);
		ZNetwork.post("clone", { item_uri: model_uri }, function(err, newmodel) {
			if (!err) {
				// done on server ZNetwork.post("activity", "clone", model_uri);
				model.clones = (model.clones || 0) + 1;
				ZProps.set(model_uri, model);
				ZProps.set(newmodel.uri, newmodel);
			}
			callback(err, err ? model.uri : newmodel.uri);
		});
	},
	getModel: function(service) {
		return service.nodes.find(n => n.kind === "modelsource");
	},
	assignDefaultPropertyValues: function(item) {
		let spec = ZProps.get(item.type + ".spec") || { fields: [] };
		(spec.fields || []).forEach( p => {
			if (p["default"]) {
				item[p.field] = item[p.field] || p["default"];
			}
		});
	},
	activity: function(item, which) {
		ZNetwork.post("activity", which, item.uri);
		item[which] = (item[which] || 0) + 1;
		ZProps.set(item.uri, item);
	},
	track: function(tracking_uri) {
		ZNetwork.post("tracking", tracking_uri);
		ZProps.set(tracking_uri, (ZProps.get(tracking_uri) || 0) + 1);
	},
	unserialize: function(graph) {
		graph.nodes = graph.nodes || [];
		return graph;
	},
	serialize: function(graph) {
		let g = Object.assign({}, graph);
		delete g.ops;
		return g;
	},
	getUser: function(uri, callback) {
		ZNetwork.get("user", uri, null, (err, userplus) => {
			if (err || !userplus) {
				return callback(err || "Not found", null);
			}
			ZProps.set(uri, userplus.user);
			ZProps.set(uri + ".settings", userplus.settings || {});
			callback(err, userplus.user);
		});
	},
	getThing: function(uri, callback) {
		var item = ZProps.get(uri);
		if (item) {
			callback(null, item);
		} else {
			ZNetwork.get("thing", uri, null, (err, thing) => {
				if (err || !thing) {
					return callback(err || "Not found", null);
				}
				callback(err, thing);
			});
		}
	},
	getBundle: function(uri, callback) {
		var item = ZProps.get(uri);
		if (false) { // TESTTT need whle bundle item) {
			callback(null, item);
		} else {
			ZNetwork.get("bundle", uri, null, (err, bundle) => {
				if (err || !bundle) {
					ZLog.error("LOADED service: err=" + err, { uri: uri, err: err });
					return callback(err || "Not found", null);
				}
				let { thing, types, history_with_thing, history_with_user, owner, architectures, specs /*, notfounds */ } = bundle;
ZLog.debug("LOADED service history_with_thing: " + ZUtil.inspect(history_with_thing));
ZLog.debug("LOADED service history_with_user: " + ZUtil.inspect(history_with_user));
ZLog.debug("LOADED service owner stats: " + ZUtil.inspect(owner));
ZLog.debug("LOADED service : " + ZUtil.inspect(thing));
ZLog.debug("LOADED service types: " + ZUtil.inspect(types));
				ZProps.set(thing.uri, thing);
				types.forEach( t => { if (t) { ZProps.set(t.uri, t) } } );
				specs.forEach( spec => { if (spec) { ZProps.set(spec.uri, spec) } } );
				ZProps.set(uri + ".history_with_thing", history_with_thing);
				ZProps.set(thing.group + ".history_with_user", history_with_user);
				ZProps.set(owner.uri, owner);
				if (thing.kind === "service") {
					architectures && architectures.forEach( t => { if (t) { ZProps.set(t.uri, t) } } );
					AMC.getFlattenedService(thing).forEach( n => { ZProps.set(n.uri, n) } );
					ZProps.set("architectures", architectures);
				}
				// ZNetwork.post("history", uri);
				callback(null, thing);
			});
		}
	},
	getHistory: function(callback) {
		ZNetwork.get("history", (err, list) => {
			callback(err, list);
		});
	},
	
	relate(uri, how, callback) {
		ZNetwork.post("relate", how, null, { item_uri: uri }, (err, item_with_stats) => {
			if (!err) {
				ZProps.set(uri, item_with_stats);
			}
			callback();
		});
	},
	search: function(kind, search, callback) {
		ZNetwork.get("search", search ? "is:" + kind + "+" + search : kind, function(err, list) {
			if (err) {
				list = [];
			} else if (search) {
				list = list[kind + "s"];
			}
			for (let i = 0; i < list.length; ++i) {
				ZProps.set(list[i].uri, list[i]);
			}
			callback(err, list);
		});
	},
	best: function(kind, search, callback) {
		ZNetwork.get("search", kind, search, function(err, list) {
			if (err) {
				list = [];
			} else {
				list = list.services || list.parts || list["*"];
			}
			for (let i = 0; i < list.length; ++i) {
				ZProps.set(list[i].uri, list[i]);
			}
			callback(err, list);
		});
	},
	getFlattenedService: function(service) {
		let nodes = [];
		for (let i = 0; i < service.nodes.length; ++i) {
			let n = service.nodes[i];
			nodes.push(n);
			if (n.nodes) {
				nodes = nodes.concat(this.getFlattenedService(n));
			}
		}
		return nodes;
	},
	getSettingURI(which) {
		let settings = ZProps.get("usersettings") || {};
		switch (which) {
			case "wtf" :
				return settings.wtf || AMCConstants.DEFAULT_WTF_URI;
			case "freakout" :
				return settings.freakout || AMCConstants.DEFAULT_FREAKOUT_URI;
			case "helpmechoose" :
				return settings.helpmechoose || AMCConstants.DEFAULT_HELPMECHOOSE_URI;
			case "rockpile" :
				return settings.rockpile || AMCConstants.DEFAULT_ROCKPILE_URI;
			case "themes" :
				return settings.themes || AMCConstants.DEFAULT_THEMES_URI;
			default :
				ZLog.error("AMC does not know this setting: " + which);
		}
	},

	getSetting(which) {
//		let lookup = { theme: theme, wtf: wtf, freakout: freakout, helpmechoose: helpmechoose };
		return this[which] || ZProps.get(which);
	},
	getNinjaURI() {
		return (ZProps.get("usersettings") || {}).ninjauri || AMCConstants.DEFAULT_NINJA_URI;
	},
	useSetting(setting, callback) {
		let which = setting.kind;
		this[which] = setting;
		ZProps.set(which, setting);
		let settings = ZProps.get("usersettings");
		if (settings[which] !== setting.uri) {
			settings[which] = setting.uri;
			ZNetwork.post("thing", settings.uri, null, { data: settings }, (err, result) => {
				ZProps.set("usersettings", settings);
				if (callback) {
					callback(err);
				}
			});
		} else {
			if (callback) {
				callback();
			}
		}
	},
/*
	loadSetting(which, callback) {
		let uri = this.getSettingURI(which);
		ZNetwork.get("thing", uri, (err, setting) => {
			if (!err) {
				ZProps.set(uri, setting);
				if (!this[which]) {
					this[which] = setting;
					ZProps.set(which, setting);
				}
				callback(err, setting);
			} else {
				callback("Problem loading default setting");
			}
		});
	},
*/
	// loads initial defaults
	loadSettings(whichs, callback) {
		let uris = whichs.map( w =>  this.getSettingURI(w) );
		AMC.list(uris, (err, settings) => {
			if (!err) {
				whichs.forEach( (w, index) => {
					if (!this[w]) {
						this[w] = settings[index];
						ZProps.set(w, settings[index]);
						if (this[w] && w === "themes") {
							this[w].list.forEach( t => {
console.log("loaded theme=" + t.uri);
								ZProps.set(t.uri, t);
							});
							let theme_uri = ZProps.get("usersettings").theme || AMCConstants.DEFAULT_THEME_URI;
							ZProps.set("theme", ZProps.get(theme_uri));
						}
					}
				});
				callback();
			} else {
				callback("Problem loading default settings");
			}
		});
	},
	cycleTheme(direction) {
		let theme_uri = (ZProps.get("theme") || {}).uri;
		let themes = ZProps.get("themes");
		let theme;
		let list = themes.list;
		for (let i = 0; i < list.length; ++i) {
			if (list[i].uri === theme_uri) {
				theme = list[(list.length + i + (direction || 1)) % list.length];
				break;
			}
		}
		if (!theme) {
			theme = list[0];
		}
		ZProps.set("theme", theme);
		let user = ZProps.get("user");
		let settings = ZProps.get("usersettings");
		settings.theme = theme.uri;
		AMC.saveUser(user, settings, (err) => { });
	},
	getAPI(service) {
		return 'fetch("https://automatic.ai/api/v1/call/predict", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify( { service_uri: "' + service.uri + '", apikey: YOUR_API_KEY, payload: YOUR_CSV_DATA } ) } );';
	},
	getPricingPlans(callback) {
		let plans = ZProps.get("plans");
		if (!plans) {
			ZNetwork.get("checkout:plans", (err, plans) => {
				if (!err) {
					ZProps.set("plans", plans);
				}
				callback(err, plans);
			});
		} else {
			callback(null, plans);
		}
	},
	getSpec(node, callback) {
		ZLog.debug("getSpec", {node: node});
		let spec = node.type ? ZProps.get(node.type + ".spec") : null; // 6-10-2020[];
		if (spec) {
			return callback(null, spec);
		}
		ZNetwork.get("spec", node.uri, (err, spec) => {
			if (!err && spec) {
				ZProps.set(node.uri + ".spec", spec);
			}
			callback(err, spec);
		});
	},
	assureSpecAndImpLoaded(node, callback) {
		let uris_to_load = [];
		if (node.kind === "model" || node.kind === "pipeline") {
			return callback();
		}
		if (!ZProps.get(node.uri + ".spec")) {
			uris_to_load.push(node.type + ".spec");
		}
		if (!ZProps.get(node.uri + ".imp")) {
			uris_to_load.push(node.type + ".imp");
		}
		return AMC.list(uris_to_load, callback);
	},
	buildHTMLFromMarkup(str) {
		let parts = [];
		let close = 0;
		let key = 1;
		while (str.indexOf("[URL=", close) !== -1) {
			let start = str.indexOf("[URL=", close);
			let end = str.indexOf("]", start);
			if (end === -1) {
				break;
			}
			close = str.indexOf("[/URL]", end);
			if (close === -1) {
				break;
			}
			parts.push(<span key={key++}>{str.substring(0, start)}</span>);
			parts.push(<a key={key++} href={str.substring(start + "[URL=".length, end)}>{str.substring(end + 1, close)}</a>);
			str = str.substring(close + "[/URL]".length);
		}
		parts.push(<span key={key++}>{str}</span>);
		return parts;
	},
	getNodeThumb(node, forcekind) {
		let thumb;
		if (!node) { 
			thumb = "/images/transparent.gif";
		} else {
			thumb = node.thumb;
			if (!thumb || forcekind) {
				thumb = KINDS[node.kind] && <FontAwesomeIcon icon={KINDS[node.kind].icon} />;
			}
			if (!thumb) {
				if (!node.owner || node.owner === "automatic.ai") {
					thumb = "/images/automatic.png";
				} else {
					let hash = 0;
					for (let i = 0; i < node.owner.length; ++i) {
						hash += node.owner.charCodeAt(i);
					}
					thumb = <span className="NodeOwnerIcon" style={{backgroundColor: AMCConstants.NODE_OWNER_ICON_BG_COLORS[hash % AMCConstants.NODE_OWNER_ICON_BG_COLORS.length]}}>{node.owner[0]}</span>
				}
			}
		}
		return thumb;
	},
	getNodeThumbElement(node, classname, large) {
		let thumb = this.getNodeThumb(node);
		return (
			typeof thumb === "string" ?
				<div className={classname} style={{backgroundImage: "url(" + (large ? thumb.replace("c_limit,h_60,w_90", "t_big_thumb") : thumb) + ")", backgroundSize: thumb.endsWith(".jpg") ? "cover" : "cover", backgroundRepeat: "no-repeat"}} title={node.kind + " " + node.name} ></div>
			:
				<div className={classname} title={node.kind + " " + node.name} >{thumb}</div>
		);
	},
	genThumbFromName(name) {
		if (typeof name !== "string") {
			name = name.uri;
		}
		if (name === "automatic.ai") {
			return <img alt="" className="RockstarUserThumbElement" title={name} src="/images/automatic.png" />
		}
		let hash = 0;
		for (let i = 0; i < name.length; ++i) {
			hash += name.charCodeAt(i);
		}
		return <span className="DefaultUserIcon" title={name} style={{background: AMCConstants.NODE_OWNER_ICON_BG_COLORS[hash % AMCConstants.NODE_OWNER_ICON_BG_COLORS.length]}}><span>{name[0]}</span></span>
	},
	getUserThumbElement(user) {
		// TODO load user and get their thumb
		return user.avatar ? <img alt="avatar" className="RockstarUserThumbElement" src={user.avatar} /> : this.genThumbFromName(user.uri);
	},
	getUserOrGroupThumbElement(uri, classname) {
		// TODO load group and get their thumb
		let user = ZProps.get("user");
		let entity = user.uri === uri ? user : uri;
		return entity && entity.thumb ? <img alt="avatar" className={classname || "RockstarUserThumbElement"} src={entity.thumb} title={entity.name} /> : this.genThumbFromName(entity);
	},
	getPermissionsThumbElement(item) {
		switch (item.permissions) {
			case "private" :
				return <span style={{color: "#e00"}}><FontAwesomeIcon icon={faLock} /></span>
			case "public" :
				return <span style={{color: "#0a0"}}><FontAwesomeIcon icon={faCheckCircle} /></span>
				//return <FontAwesomeIcon icon={faUnlock} />
			default :
				return <FontAwesomeIcon icon={faLockOpen} />
		}
	},
	getPublishedThumbElement(item) {
		switch (item.published) {
			case true :
				return <span style={{color: "#0a0"}}><FontAwesomeIcon icon={faCheckCircle} /></span>
			case false :
				return <span style={{color: "#d00"}}><FontAwesomeIcon icon={faCircle} /></span>
			default :
				return <FontAwesomeIcon icon={faCircle} />
		}
	},
	// has changed since deploy, test, or training
	clearIsOutOfDate: function(service_uri) {
		ZProps.set(service_uri + ".changes", null);
	},
	isOutOfDate: function(service, force, callback) {
		let changes = ZProps.get(service.uri + ".changes");
//force = true;
		if (!force && changes) {
			return callback(null, changes.changed);
		}
		let uris_to_load = [];
		AMC.getFlattenedService(service).forEach( n => { 
			if (n.kind !== "pipeline" && n.kind !== "ui" && !ZProps.get(n.type + ".imp")) { uris_to_load.push(n.type + ".imp") } } );
		this.SUPPORT_FILES = ["core/deployer/ATMService.py"];
		this.SUPPORT_FILES.forEach( f => { if (!ZProps.get(f)) { uris_to_load.push(f) } } );
		if (uris_to_load.length > 0) {
			return AMC.list(ZUtil.uniq(uris_to_load), (err) => {
				this.isOutOfDate(service, force, callback);
			});
		}
		let checksum = this._calcChecksum(service);
		AMC.get(service.uri + ".runtime", (err, runtime) => {
			ZLog.debug("runtime.lambda_checksum=" + (runtime && runtime.lambda_checksum) + ", local service checksum: " + checksum);
			ZProps.set(service.uri + ".changes", runtime && runtime.lambda_checksum !== checksum);
			callback(null, runtime && runtime.lambda_checksum !== checksum);
		});
	},
	_calcChecksum(service) {
		let doc = [];
		let nodes = AMC.getFlattenedService(service);
		nodes.sort( (a, b) => a.uri - b.uri ).forEach( n => {
			if (n.kind !== "pipeline" && n.kind !== "ui") {
				let spec = ZProps.get(n.type + ".spec");
				if (!spec) {
					ZLog.warn("isOutOfDate - no spec found for: " + n.type);
				}
				let imp = ZProps.get(n.type + ".imp");
				if (!imp) {
					ZLog.warn("isOutOfDate - no imp found for: " + n.type);
				}
				doc.push(n);
				doc.push(spec);
				doc.push(imp);
			}
		});
		this.SUPPORT_FILES.forEach( f => doc.push(ZProps.get(f).code) );
		let checksum = ZUtil.hashCode(JSON.stringify(doc));
		return checksum;
	},
	hashCode(component) {
		return ZUtil.hashCode(JSON.stringify(component));
	},
	getCapacity: function(group) {
		let capacity = (group.capacity || 0) + (group.battery || 0);
		if (capacity < 0) {
			APP.showBatteryLowMsg();
		}
		return capacity;
	},
	setUser: function(user) {
		ZProps.set("user", user);
		if (user.uri === user.group) {
			ZProps.set("usergroup", user);
		}
	},
	loadDemos: function(callback) {
		let demos = ZProps.get("demos");
		if (demos) {
			return callback(null, demos);
		}
		let DEMOS = [
			"core/service/example-sklearn-housing-price-predictor",
			"core/service/example-keras-mnist", 
			"core/service/example-keras-fashion-mnist", 
			"core/service/example-pytorch-neural-style-transfer",
			"core/service/example-pytorch-mnist", 
			"core/service/example-pytorch-fashion-mnist"
		];
		ZNetwork.post("things", { uris: DEMOS, ttl: 15*60*1000, withruntimes: true, withstats: true }, (err, list) => {
			if (!err) {
				ZProps.set("demos", list);
			}
			callback(err, list);
		})
	},
	loadMyThings: function(callback) {
		let mythings = ZProps.get("mythings");
		if (mythings) {
			return callback(null, mythings);
		}
		ZNetwork.get("things", ZProps.get("user").uri, (err, mythings) => {
			mythings = mythings || [];
			if (!err) {
				ZProps.set("mythings", mythings);
			}
			callback(err, mythings || []);
		});
	},
	isPremiumUser: function(user) {
		if (!user) {
			user = ZProps.get("user");
		}
		return user.plan !== "guest" && user.plan !== "member";
	}
}
export default AMC;



// WEBPACK FOOTER //
// ./src/AMC.js